export { TIMEZONES } from "./timezones";
export const DEFAULT_TIMEZONE = "America/Phoenix";

import {
  QUESTIONNAIRE_OPT_IN_FIELD_TYPE_EMAIL,
  QUESTIONNAIRE_OPT_IN_FIELD_TYPE_PHONE,
  QUESTIONNAIRE_OPT_IN_FIELD_TYPE_FIRST_NAME,
  QUESTIONNAIRE_OPT_IN_FIELD_TYPE_LAST_NAME,
} from "@icebergeradmin/common";

export const INDUSTRY_OPTIONS = [
  { label: "Automative", value: "Automative" },
  { label: "Books and Literature", value: "Books and Literature" },
  { label: "Business and Finance", value: "Business and Finance" },
  { label: "Careers", value: "Careers" },
  { label: "Education", value: "Education" },
  { label: "Events and Attractions", value: "Events and Attractions" },
  { label: "Family and Relationships", value: "Family and Relationships" },
  { label: "Fine Art", value: "Fine Art" },
  { label: "Food & Drink", value: "Food & Drink" },
  { label: "Healthy Living", value: "Healthy Living" },
  { label: "Hobbies & Interests", value: "Hobbies & Interests" },
  { label: "Home & Garden", value: "Home & Garden" },
  { label: "Medical Health", value: "Medical Health" },
  { label: "Movies", value: "Movies" },
  { label: "Music and Video", value: "Music and Video" },
  { label: "News and Politics", value: "News and Politics" },
  { label: "Personal Finance", value: "Personal Finance" },
  { label: "Pets", value: "Pets" },
  { label: "Pop Culture", value: "Pop Culture" },
  { label: "Real Estate", value: "Real Estate" },
  { label: "Religion & Spirituality", value: "Religion & Spirituality" },
  { label: "Science", value: "Science" },
  { label: "Shopping", value: "Shopping" },
  { label: "Sports", value: "Sports" },
  { label: "Style & Fashion", value: "Style & Fashion" },
  { label: "Technology & Computing", value: "Technology & Computing" },
  { label: "Television", value: "Television" },
  { label: "Travel", value: "Travel" },
  { label: "Video Gaming", value: "Video Gaming" },
];

export const OPTIN_FIELDS_OPTIONS = [
  { label: "First Name", value: QUESTIONNAIRE_OPT_IN_FIELD_TYPE_FIRST_NAME },
  { label: "Last Name", value: QUESTIONNAIRE_OPT_IN_FIELD_TYPE_LAST_NAME },
  { label: "Email", value: QUESTIONNAIRE_OPT_IN_FIELD_TYPE_EMAIL },
  { label: "Phone", value: QUESTIONNAIRE_OPT_IN_FIELD_TYPE_PHONE },
];

export const DAYS_OF_WEEK = [
  {
    label: "Sunday",
    value: "sunday",
  },
  {
    label: "Monday",
    value: "monday",
  },
  {
    label: "Tuesday",
    value: "tuesday",
  },
  {
    label: "Wednesday",
    value: "wednesday",
  },
  {
    label: "Thursday",
    value: "thursday",
  },
  {
    label: "Friday",
    value: "friday",
  },
  {
    label: "Saturday",
    value: "saturday",
  },
];

export const HOST_PRIORITY_MAXIMUM = 1;
export const HOST_PRIORITY_MEDIUM = 2;
export const HOST_PRIORITY_MINIMUM = 3;

export const MAX_UPLOAD_SIZE = 2 * 1024 * 1024; // 2MB
export const MAX_EMAIL_IMAGE_SIZE = 3 * 1024 * 1024; // 3MB

export const DEFAULT_PAGE_SIZE = 20;
